export default "__VITE_ASSET__fa05f05e__"